<template>
  <span>
    <MakeSheetExcel
      v-if="needExcel"
      :skip-page="skipPage"
    />

    <MakePayrollExcel
      v-if="needPayrollExcel"
      :skip-page="skipPage"
    />

    <MakeUserExcel
      v-if="needUserExcel"
      :skip-page="skipPage"
    />
  </span>
</template>

<script>
import MakeSheetExcel from './MakeSheetExcel.vue'
import MakePayrollExcel from './MakePayrollExcel.vue'
import MakeUserExcel from './MakeUserExcel.vue'

export default {
  name: 'IndexExecl',
  components: {
    MakeSheetExcel,
    MakePayrollExcel,
    MakeUserExcel,
  },
  props: {
    needExcel: {
      type: Boolean,
      required: true,
    },
    needPayrollExcel: {
      type: Boolean,
      required: true,
    },
    needUserExcel: {
      type: Boolean,
      required: true,
    },
    skipPage: {
      type: Number,
      required: true,
    },
  },
}
</script>
